<template>

  <div>

    <ChecklistEnvironmentOccurrenceDialog
        :checklist-item-id="modalOccurrenceItemId"
        :type-checklist-item="modalOccurrenceItemName"
        :checklist-environment-id="modalOccurrenceItemEnvironmentId"
        :business-type-survey="businessTypeSurvey"
        :user-access-budget-show-price="userAccessBudgetShowPrice"
        :occurrence="modalOccurrenceItemOccurrence"
        :set-tab-index="modalOccurrenceItemTabIndex"
        v-if="modalOccurrenceItemShow"
        @onClose="onCloseModalItem"
    />

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 disable-default-buttons
                 title-items="Apontamentos"
                 hide-header
                 disable-footer-length
                 primary-key-column="checklistItemOccurrenceId"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <template #default>

        <t-input v-model="form.checklistItemOccurrenceId" hidden/>


        <b-col cols="12" class="mb-2">


          <t-msg info v-if="budgetEnabled && userAccessBudgetShowPrice && listIsLoaded">
            Você pode adicionar itens na inspeção orçamentária sem definir preços.<br />
            Ao finalizar, um orçamento será criado automaticamente.

            <div v-if="quoteCodeLabel !== ''">
              Para revisar e preencher os valores, acesse o orçamento:
              <b-link :to="{path:'/business/quote/'+quoteNumber}">
                {{ quoteCodeLabel }}
              </b-link>
            </div>
          </t-msg>

          <b-row>

            <t-input cols="2" @change="executeSearchInput" v-model="form.occurrenceCodeLabel" label="Cód. Apontamento"/>

            <t-input cols="2" @change="executeSearchInput" v-model="form.typePathology" label="Anomalia"/>

            <t-input cols="2" @change="executeSearchInput" v-model="form.environment" label="Ambiente"/>

            <t-input cols="2" @change="executeSearchInput" v-model="form.typeChecklistItem" label="Item"/>

            <t-input-search v-model="form.typeCriticalityId" cols="2" :options="typeCriticalityOptions"
                            @change="executeSearchInput"
                            label="Criticidade" placeholder="Todas"
                            select
            />

            <t-input-search cols="2" v-model="form.statusItemOccurrence"
                            @change="executeSearchInput"
                            :options="StatusChecklistOccurrenceItemType.list"
                            placeholder="Todas"
                            label="Status Apontamento" select/>

          </b-row>

          <b-row v-if="pageListIsLoaded && items.length === 0" class="mt-2">
            <b-col cols="12">

              <t-msg info>Nenhum apontamento encontrado</t-msg>
            </b-col>

          </b-row>

        </b-col>


      </template>

      <template #list-content="{item}">

        <b-col cols="12">

          <b-row class="mt-1">


            <b-col cols="7">

              <div style="width: 5px; height: 95px; position: absolute; left: 3px; top:3px; border-radius: 3px"
                   :class="{
                          'bg-warning':item.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING,
                          'bg-danger':item.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW,
                          'bg-success':item.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_CLOSE,
                          }"></div>

              <div class="link" @click="openDialogOccurrence(item,0)">

                <div v-if="budgetEnabled">

                  <b-card-title style="font-size: 16px" class="mb-0">{{ item.spotFolder }} - {{ item.environment }}
                    <span v-if="item.environmentComplement !== ''"> - {{ item.environmentComplement }}</span>
                  </b-card-title>

                  <div>

                    <b-card-title style="font-weight: normal" class="mb-0">{{ item.typeChecklistItem }}</b-card-title>

                    {{ item.typePathologyAutomatically }} ({{ item.sector }}) <br/>

                    <div v-if="item.description !== ''">{{ item.description }}</div>
                    <div v-else><br/></div>

                    <div>

                      <div v-if="item.statusItemOccurrence !== StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW">

                        <small  class="opacity-6 mr-2" v-if="objValid(item.occurrenceCodeLabel) && userAccessBudgetShowPrice">
                          Valor Un. {{ item.budgetPrice | money }}
                        </small>
                        <small v-else><br /></small>

                        <small class="opacity-6 mr-2" v-if="objValid(item.occurrenceCodeLabel)">
                          <i class="fa fa-info-circle"></i>
                          <span v-if="objValid(item.otherCodeLabel)">{{item.otherCodeLabel}}</span>
                          <span v-else> {{ item.occurrenceCodeLabel }}</span>
                        </small>

                        <small class="opacity-6">
                          <i class="fa fa-user"></i>
                          {{ item.occurrenceCreatedUser }}
                        </small>
                        <small class="opacity-6 ml-2">
                          <i class="fa fa-calendar-alt"></i>
                          {{ item.occurrenceCreatedDate | datetime }}

                        </small>


                      </div>

                      <div v-else>

                        <small  class="opacity-6 mr-2" v-if="userAccessBudgetShowPrice">
                          Valor Un. {{ item.budgetPrice | money }}
                        </small>
                        <small v-else><br /></small>

                      </div>


                    </div>

                  </div>


                </div>

                <div v-else>

                  <b-card-title class="mb-0">{{ item.typeChecklistItem }}</b-card-title>

                  {{ item.typePathologyAutomatically }} ({{ item.sector }}) <br/>

                  {{ item.description }} <br/>

                  {{ item.spotFolder }} - {{ item.environment }} <br/>


                  <div
                      v-if="item.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW">

                    <small class="opacity-6 mr-2" v-if="objValid(item.occurrenceCodeLabel)">
                      <i class="fa fa-info-circle"></i>
                      <span v-if="objValid(item.otherCodeLabel)">{{item.otherCodeLabel}}</span>
                      <span v-else> {{ item.occurrenceCodeLabel }}</span>
                    </small>

                    <small class="opacity-6">
                      <i class="fa fa-user"></i>
                      {{ item.logControl.createdUser }}
                    </small>
                    <small class="opacity-6 ml-2">
                      <i class="fa fa-calendar-alt"></i>
                      {{ item.logControl.createdDate | datetime }}
                    </small>

                  </div>

                  <div v-else>

                    <small class="opacity-6 mr-2" v-if="objValid(item.occurrenceCodeLabel)">
                      <i class="fa fa-info-circle"></i>
                      <span v-if="objValid(item.otherCodeLabel)">{{item.otherCodeLabel}}</span>
                      <span v-else> {{ item.occurrenceCodeLabel }}</span>
                    </small>

                    <small class="opacity-6">
                      <i class="fa fa-user"></i>
                      {{ item.occurrenceCreatedUser }}
                    </small>
                    <small class="opacity-6 ml-2">
                      <i class="fa fa-calendar-alt"></i>
                      {{ item.occurrenceCreatedDate | datetime }}

                    </small>


                  </div>

                </div>


              </div>


            </b-col>

            <b-col cols="1" class="d-flex align-items-center">

              <t-progress-bar-line v-if="item.conclusion > 0" :progress="item.conclusion"/>

            </b-col>


            <b-col cols="1" class="d-flex align-items-center">


              <div v-if="budgetEnabled">{{ item.budgetQuantity | number }}{{ item.budgetUnit }}</div>

              <div v-else-if="objValid(item.processedDate)">

                <b-icon-cloud-check v-if="item.processedSuccess" style="scale: 1.5" v-b-tooltip.hover.ds500
                                    :title="'Sincronizado com sucesso em: ' + ui.convertDateBR(item.processedDate,true)"
                                    class="text-success"/>

                <b-icon-cloud-slash v-else style="scale: 1.5" v-b-tooltip.hover.ds500
                                    :title="'Sincronizado com erro em: ' + ui.convertDateBR(item.processedDate,true) + ' - erro: ' +item.processedError"
                                    class="text-danger"/>

              </div>

            </b-col>

            <b-col cols="3" class="d-flex justify-content-end align-items-center mt-1">

              <div v-if="budgetEnabled && userAccessBudgetShowPrice"><b>{{ item.budgetTotalPrice | money }}</b></div>

              <div v-else>

                <div>

                  <b-badge variant="danger"
                           class="mr-3"
                           v-if="item.typeCriticalityDegree > 1 && item.typeCriticalityLineClass === 'bg-danger-light'">
                    {{ item.typeCriticality }}
                  </b-badge>
                  <b-badge variant="warning"
                           class="mr-3"
                           v-else-if="item.typeCriticalityDegree > 1 && item.typeCriticalityLineClass === 'bg-warning-light'">
                    {{ item.typeCriticality }}
                  </b-badge>

                  <b-badge v-if="objValid(item.executorSignaled)" class="mr-3" variant="info">Sinalizada
                    <t-help :title="getSignaledText(occurrence)"/>
                  </b-badge>

                </div>

                <t-button small outline-danger class="mr-1"
                          v-show="item.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW && !objValid(item.processedDate)"
                          @click="confirmDeleteNewOccurrence(item.checklistItemOccurrenceId)">
                  <i class="nav-link-icon lnr-trash"/>
                </t-button>

                <t-button small outline-secondary class="mr-1"
                          @click="openDialogOccurrence(item,1)">
                  <i class="nav-link-icon lnr-camera"/>
                  <span v-show="item.qtyPhotos !== undefined && item.qtyPhotos > 0"
                        v-b-tooltip.hover.ds500 :title="'Qtd. novas fotos: ' + item.qtyPhotos"
                        class="badge badge-info badge-pill badge-dot badge-dot-sm"/>
                </t-button>

                <t-button small outline-secondary class="mr-1"
                          @click="openDialogOccurrence(item,2)">
                  <i class="nav-link-icon lnr-bubble"/>
                  <span v-show="objValid(item.comment)"
                        v-b-tooltip.hover.ds500 title="Novo comentário inserido"
                        class="badge badge-info badge-pill badge-dot badge-dot-sm"/>
                </t-button>

                <t-button small outline-secondary @click="infoDevelopment()">
                  <i class="nav-link-icon lnr-map-marker"/>
                </t-button>

              </div>


            </b-col>


          </b-row>

        </b-col>

      </template>

    </t-form-list>

    <div v-if="budgetEnabled && userAccessBudgetShowPrice && listIsLoaded" class="d-flex mr-3 ml-3  justify-content-between align-content-center">


      <div style="font-size: 15px">Valor Total orçado nesta Inspeção:</div>
      <div style="font-size: 25px; margin-right: 20px"><b>{{checklistBudgetTotalPrice | money}}</b></div>


    </div>

    <div class="pt-0 p-2 mt-5" v-if="items.length > 0">

      Legenda:<br/>

      <table>
        <tr>
          <td>
            <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-success"></div>
          </td>
          <td class="pl-1">Apontamento finalizado nesta inspeção</td>
        </tr>
        <tr>
          <td>
            <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-warning"></div>
          </td>
          <td class="pl-1">Apontamento pendente de inspeção anterior</td>
        </tr>
        <tr>
          <td>
            <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-danger"></div>
          </td>
          <td class="pl-1">Apontamento novo nesta inspeção</td>
        </tr>

      </table>

    </div>


    <div v-else-if="items.length === 0 && listIsLoaded">

      <div v-if="businessTypeSurvey  === SurveyType.type.BUDGET">

        <t-msg info v-if="budgetEnabled">Nenhum apontamento relacionado a esta inspeção do tipo 'Orçamento'.</t-msg>
        <t-msg info v-else>Nenhum apontamento relacionado a esta inspeção do tipo 'comum' encontrado (não habilitado
          para orçamento).
        </t-msg>
      </div>

      <div v-else>

        <t-msg info>Nenhum apontamento relacionado a esta inspeção</t-msg>


      </div>

    </div>


  </div>


</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import pageListMixin from "@/mixins/page/pageListMixin";
import StatusChecklistEnvironmentType from "@/model/types/modules/checklist/StatusChecklistEnvironmentType";
import StatusChecklistOccurrenceItemType from "@/model/types/modules/checklist/StatusChecklistOccurrenceItemType";
import TypeCriticalityService from "@/services/modules/checklist/TypeCriticality.service";
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";
import ChecklistEnvironmentOccurrenceDialog
  from "@/views/modules/checklist/Checklist/ChecklistEnvironmentOccurrenceDialog";
import SurveyType from "@/model/types/modules/checklist/SurveyType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageListMixin, pageFormListMixin],
  components: {tFormList, ChecklistEnvironmentOccurrenceDialog},
  name: 'ChecklistEnvironment',
  data() {
    return {
      ui,
      SurveyType,
      StatusChecklistEnvironmentType,
      StatusChecklistOccurrenceItemType,
      path: "checklist/item/occurrence", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "checklistId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "checklistItemOccurrenceId", keyDelete: "checklistItemOccurrenceId"},
      ],
      form: {
        checklistId: this.foreignKey,
        occurrenceCodeLabel: "",
        typePathology: "",
        environment: "",
        typeChecklistItem: "",
        typeCriticalityId: 0,
        statusItemOccurrence: 0,
        status: 1,
        budgetEnabled: this.budgetEnabled,
        sorted: "statusItemOccurrence,spotFolder,environment",
      },
      error: {//Campos que podem receber retorno de erro do backend
        code: "",
      },
      typeCriticalityOptions: [],
      request: {},
      modalOccurrenceItemEnvironmentId: 0,
      modalOccurrenceItemShow: false,
      modalOccurrenceItemId: 0,            /* checklistItemId */
      modalOccurrenceItemName: ""          /*typeChecklistItem*/,
      modalOccurrenceItemOccurrence: {},  /* checklistItemOccurrenceId */
      modalOccurrenceItemTabIndex: 0,      /*Tab para exibição por padrão*/
      checklistBudgetTotalPrice: 0.0,
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  props: {
    businessTypeSurvey: Number,
    userAccessBudgetShowPrice: {
      type: Boolean,
      default: false,
    },
    budgetEnabled: {
      type: Boolean,
      default: false,
    },
    quoteId: Number,
    quoteNumber: Number,
    quoteCodeLabel: {
      type: String,
      default: "",
    },
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.listParams.append('budgetEnabled', this.budgetEnabled)
      this.listParams.append('sorted', 'statusItemOccurrence,spotFolder,environment')

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

      await TypeCriticalityService.selectList("").then((list) => {
        this.typeCriticalityOptions = list
      }).catch(error => this.responseError(error))


    },

    async onSubmit() {


    },

    mountedList() {

      this.budgetSumTotalPrice()

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    async executeSearchInput() {

      this.listIsLoaded = false


      setTimeout(async () => {
        await this.executeSearch(false, false)
      }, 100)


    },
    afterGetPage() {

      this.items = this.request
      this.listIsLoaded = true

      this.budgetSumTotalPrice()


    },

    async openDialogOccurrence(item, tabIndex) {

      this.modalOccurrenceItemShow = true
      this.modalOccurrenceItemId = item.checklistItemId
      this.modalOccurrenceItemName = item.typeChecklistItem
      this.modalOccurrenceItemEnvironmentId = item.checklistEnvironmentId
      this.modalOccurrenceItemOccurrence = item
      this.modalOccurrenceItemTabIndex = tabIndex

      this.openDialogForm('modal-checklist-item-occurrence', '')

    },

    confirmDeleteNewOccurrence(checklistItemOccurrenceId) {

      ui.msgConfirm(this, '', 'Deseja excluir esta novo apontamento?', async () => {

        await http.remove('checklist/item/occurrence', checklistItemOccurrenceId).then(async () => {
          await this.getList()
        }).catch(error => ui.generalResponseError(this, error));

      }, 'Excluir')
    },

    getSignaledText(occurrence) {
      return 'Sinalizado que foi feito em :<br />' + ui.convertDateBR(occurrence.executorSignaled, true)
    },

    async onCloseModalItem() {

      this.modalOccurrenceItemShow = false

      this.showLoadingList = false

      await this.getList()

      this.showLoadingList = true

    },

    async budgetSumTotalPrice() {

      this.checklistBudgetTotalPrice = 0

      for (let item of this.items) {

        if(item.budgetEnabled){
          this.checklistBudgetTotalPrice += item.budgetTotalPrice
        }

      }

    }




    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>